import Gateway from '../../application/Gateway'

import AppPage from '../../mixins/app-page'

export default
{
    name: 'page-sample',

    mixins: [
        AppPage
    ],

    components: {

    },

    props: {

    },

    data() {
        return {

        }
    },

    created() {

    },

    mounted() {

    },

    destroyed() {

    },

    methods: {

    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/page-sample/script.js